import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginPage from '@/views/Login.vue'
import AdminUsersPage from '@/views/admin/AdminUsers.vue'
import AdminUserDetailPage from '@/views/admin/AdminUserDetail.vue'
import UserProfilePage from '@/views/user/UserProfile.vue'
import QuickConfigPage from '@/views/user/QuickConfig.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', name: 'LoginPage', component: LoginPage },
  { path: '/admin/users', name: 'AdminUsers', component: AdminUsersPage, meta: { requiresAuth: true, role: 'admin' } },
  { path: '/admin/users/:id', name: 'AdminUserDetail', component: AdminUserDetailPage, meta: { requiresAuth: true, role: 'admin' } },
  { path: '/user/profile', name: 'UserProfile', component: UserProfilePage, meta: { requiresAuth: true, role: 'user' } },
  { path: '/user/quick-config', name: 'QuickConfig', component: QuickConfigPage, meta: { requiresAuth: true, role: 'user' } },
  { path: '*', redirect: '/login' }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
    return
  }
  const token = localStorage.getItem('token')
  const role = localStorage.getItem('role')
  if (!token) {
    next('/login')
    return
  }
  if (to.meta.role && to.meta.role !== role) {
    next(role === 'admin' ? '/admin/users' : '/user/profile')
    return
  }
  next()
})

export default router